// extracted by mini-css-extract-plugin
export default {"component":"TransferPool_component__LK3E5","searchContainer":"TransferPool_searchContainer__TImSZ","actionContainer":"TransferPool_actionContainer__T24KI"};